import { client } from "@hey-api/client-fetch";
const healthcheckHealthcheckGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get({
    ...options,
    url: "/healthcheck/"
  });
};
const updateClientsSettingsClientSettingsPost = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).post({
    ...options,
    url: "/client-settings/"
  });
};
const getFlowFlowGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get({
    ...options,
    url: "/flow/"
  });
};
const getCatalogCatalogGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get({
    ...options,
    url: "/catalog/"
  });
};
const getEstimateEstimatePost = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).post({
    ...options,
    url: "/estimate/"
  });
};
const createReportReportsPost = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).post({
    ...options,
    url: "/reports/"
  });
};
const getReportReportsReportIdGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get({
    ...options,
    url: "/reports/{report_id}"
  });
};
export {
  createReportReportsPost,
  getCatalogCatalogGet,
  getEstimateEstimatePost,
  getFlowFlowGet,
  getReportReportsReportIdGet,
  healthcheckHealthcheckGet,
  updateClientsSettingsClientSettingsPost
};
